import angular from 'angular'

import template from './vd-quick-key-folder-view.html'

/**
 * Directive for rendering a folder of quick keys.
 *
 * @module vendQuickKeys.vdQuickKeyFolderView
 */
angular.module('vendQuickKeys').directive('vdQuickKeyFolderView', function () {
  return {
    restrict: 'E',
    scope: {
      layout: '=',
    },
    template,
    bindToController: true,
    controllerAs: 'qkFolderViewCtrl',
    controller(this: $TSFixMe, $scope, $element, key, qkModals) {
      this.closeFolder = function () {
        $scope.$applyAsync(() => {
          this.layout.folder = null
        })
      }

      this.editFolder = function () {
        qkModals.editQuicKey(this.layout, this.layout.folder)
      }

      key.on($element, { ESC: () => this.closeFolder() })
    },
    link(scope, element, attrs) {
      attrs.$addClass('vd-quick-key-folder-view-container')
    },
  }
})
